import imgLeslieTeo from "@assets/events-awards/dta/img-leslie.jpg";
import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/EventsAwardsAccordionHeader";

/**
 * Component to render Leslie Teo Section on DTA Judges Page
 */
const LeslieTeoSection = (): React.ReactElement => {
  return (
    <AccordionV2
      testId="lealie-teo-section-component"
      className="rounded-bl-lg rounded-br-lg border border-t-0 border-gray-175 bg-gray-150 py-4"
      headerChildren={
        <EventsAwardsAccordionHeader
          title="Dr Leslie Teo"
          className="tracking-normal"
        />
      }
      arrowClassName="border-none h-auto w-auto -rotate-90 mr-6"
      isArrowRight
    >
      <div className="mt-4 flex flex-col border-t border-gray-175 px-6 pt-4 md:flex-row">
        <div className="mb-6 h-auto w-8/12 pr-4 md:mb-2 md:w-2/12 md:pr-5">
          <img
            src={imgLeslieTeo}
            width={576}
            height={283}
            alt="dr-leslie-teo"
            className="object-contain"
          />
        </div>

        <div className="md:w-8/12 md:pl-1 md:pr-1">
          <p className="mb-0 font-bold">Dr Leslie Teo</p>

          <p className="font-bold">
            Senior Director of AI Products, AI Singapore
          </p>

          <p>
            Leslie is Senior Director of AI Products at AI Singapore where he is
            tasked with catalysing the use of AI in businesses. He and his team
            work with companies to identify important use cases and build
            enabling AI products to support such use cases.
          </p>

          <p>
            Leslie is passionate about data, data science, machine learning, and
            AI. He pivoted from a career in economics, finance, and investing in
            2019. That year, he joined Grab as Head of Data Science, Policy, and
            Data Initiatives and Advisor to the CEO. In that role, he sought to
            answer critical business and social questions using data and build
            products that provided relevant insights, such as congestion
            patterns and creating safer bike paths. He helped lay the foundation
            for the data science and analytics role at Grab and Singtel’s
            digital bank (GxS).
          </p>

          <p>
            After Grab, Leslie was Managing Director at Great Eastern Life
            Insurance for Data and Strategic Transformation. He and his team
            were responsible for enabling data analytics and data science across
            the organisation and fostering business transformation capabilities
            to deliver value in areas such as distribution, marketing, risk
            management and digital products.
          </p>

          <p>
            Before Grab, Leslie was the Director of the Economics and Investment
            Strategy Department and Chief Economist at GIC Private Limited,
            Singapore’s sovereign wealth fund. He oversaw the team responsible
            for asset allocation, total portfolio construction, systematic
            investing, and identifying critical long-term trends that would
            impact GIC’s portfolio. He remains an advisor to the government on
            reserve management issues.
          </p>

          <p>
            Leslie was also at the International Monetary Fund. During his Fund
            career, he worked on financial sector restructuring, financial
            stability, public debt management, monetary policy and operations.{" "}
          </p>

          <p>
            He was also Head of the Financial Surveillance Division at the
            Monetary Authority of Singapore.
          </p>

          <p>
            Leslie has a strong belief in education. He was a Board member of
            the Pacific Pension and Investment Institute and the National
            University of Singapore. He was a Vice President of the Economic
            Society of Singapore, chaired the advisory board for NUS’ Faculty of
            Arts and Sciences, and advised NUS’ Investment Committee and
            Business School.
          </p>

          <p>
            Leslie has a Liberal Arts and Sciences degree from the University of
            Chicago and a Ph.D. in Economics and Finance from the University of
            Rochester. He has a Master’s in Information and Data Science from
            the University of California at Berkeley. In addition, he is a
            certified Financial Risk Manager and a CFA charter holder.
          </p>
        </div>
      </div>
    </AccordionV2>
  );
};
export default LeslieTeoSection;
